import React, { FC } from 'react';
import AgeCategorySelector from '../common/AgeCategorySelector';
import TitleDropdown from './TitleDropdown';
import { LinkContainer } from './NavigationLinksContainer';
import SubNavigationLayout from './SubNavigationLayout';
import { useLocation, useRouteMatch } from 'react-router';
import { NavigationLink } from './NavigationLink';
import './LoanFormatNavigation.scss';
import { LoanFormat } from '../../../models/LoanFormat';
import { useTranslation } from 'react-i18next';

type Props = {
    readonly showAgeSelector?: boolean;
    readonly isSticky?: boolean;
    readonly ignoreNewReleases?: boolean;
    readonly loanFormat: LoanFormat;
};

export const LoanFormatNavigation: FC<Props> = ({
    showAgeSelector,
    ignoreNewReleases = false,
    isSticky,
    loanFormat
}) => {
    const { pathname } = useLocation();
    const { url } = useRouteMatch();

    const lowercaseLoanFormat = loanFormat.toLowerCase();

    const { t } = useTranslation();

    return (
        <SubNavigationLayout
            left={<TitleDropdown isLibx={false} locationPathname={pathname} />}
            center={
                <LinkContainer>
                    <li>
                        <NavigationLink to={`${url}/featured`}>{t('menu.shop.loanFormat.featured')}</NavigationLink>
                    </li>
                    {!ignoreNewReleases ? (
                        <li>
                            <NavigationLink to={`${url}/newreleases`}>
                                {t('menu.shop.loanFormat.newReleases')}
                            </NavigationLink>
                        </li>
                    ) : null}
                    <li>
                        <NavigationLink to={`${url}/bundles`}>
                            {t('menu.shop.loanFormat.curatedCollections')}
                        </NavigationLink>
                    </li>
                    {loanFormat === LoanFormat.ePress ? (
                        <>
                            <li>
                                <NavigationLink to={`${url}/emagazines`}>
                                    {t('menu.shop.loanFormat.emagazines')}
                                </NavigationLink>
                            </li>
                            <li>
                                <NavigationLink to={`${url}/enews`}>{t('menu.shop.loanFormat.enews')}</NavigationLink>
                            </li>
                        </>
                    ) : null}
                    <li>
                        <NavigationLink to={`${url}/products`}>
                            {t('menu.shop.loanFormat.all', { context: lowercaseLoanFormat })}
                        </NavigationLink>
                    </li>
                    <li>
                        <NavigationLink to={`${url}/genres`}>{t('menu.shop.loanFormat.genres')}</NavigationLink>
                    </li>
                    <li>
                        <NavigationLink to={`${url}/publishers`}>{t('menu.shop.loanFormat.publishers')}</NavigationLink>
                    </li>
                </LinkContainer>
            }
            right={showAgeSelector && <AgeCategorySelector />}
            isSticky={isSticky}
            width="15"
        />
    );
};
